module.exports = __webpack_public_path__ + "static/media/loading.3f259006.gif";